<script lang="ts">
  import type { InboxWorkflowCellProps } from "@kontextwerk/control-web-frame/inbox-workflow/contract"
  import SourceCleanupInstructionTags from "../../../../../../_shared/_modules/source-cleanup-instruction-tags"
  import type { ContactPointSourceCleanupDraft, ContactPointSourceCleanupRow } from "../../contract"

  let props: InboxWorkflowCellProps<ContactPointSourceCleanupRow, ContactPointSourceCleanupDraft> =
    $props()

  const row = $derived(props.row)
</script>

<SourceCleanupInstructionTags instructions={row.sourceSyncInstructions} muted={props.disabled} />
